import api from '../../../../api'

export const FETCH_TRAVEL_HISTORY_PENDING = 'FETCH_TRAVEL_HISTORY_PENDING'
export const FETCH_TRAVEL_HISTORY_FULFILLED = 'FETCH_TRAVEL_HISTORY_FULFILLED'
export const FETCH_TRAVEL_HISTORY_REJECTED = 'FETCH_TRAVEL_HISTORY_REJECTED'

export const CHANGE_TRAVEL_HISTORY = 'CHANGE_TRAVEL_HISTORY'

export function changeTravelHistory(name, value) {
  return dispatch => {
    dispatch({ type: CHANGE_TRAVEL_HISTORY, payload: { name, value } })
  }
}

export function findAllTravelHistorys(filter) {
  
  return dispatch => new Promise((resolve, reject) => {

    dispatch({ type: FETCH_TRAVEL_HISTORY_PENDING });
    api({
      method: 'post',
      data: {
        query: `
                query findAllTravelHistorys {
                  historicoViagens(
                    veiId: ${filter.veiculo} 
                    parDhi: "${filter.dataHoraInicial}"
                    parDhf: "${filter.dataHoraFinal}") {
                      rigIni
                      rigPin
                      rigLti
                      rigLgi
                      rigMot
                      rigOdi
                      rigFim
                      rigPfm
                      rigLtf
                      rigLgf
                      rigOdf
                      rigOdf
                      rigDur
                      rigDst
                      rigVxs
                      rigVxc
                  }
                }
                `
      }
    }).then((result) => {
      const { errors, data } = result.data
      if (errors) {
        dispatch({ type: FETCH_TRAVEL_HISTORY_REJECTED, payload: errors });
        reject(errors);
      } else {
        const { historicoViagens } = data
        dispatch({ type: FETCH_TRAVEL_HISTORY_FULFILLED, payload: historicoViagens });
        resolve(data);
      }
    }).catch((error) => {
      dispatch({ type: FETCH_TRAVEL_HISTORY_REJECTED, error });
      reject(error);
    });

  });

}